export default __webpack_public_path__ + "static/media/mallorca.a90bb36d.jpg";